import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import { useLocation, useNavigate } from "react-router-dom";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useUtils from "hooks/useUtils";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { EventsFilterDTO } from "utils/helpers/models/users/events-filter.dto";
import useUsers from "containers/user-management/useHooks";
import { EventDTO } from "utils/helpers/models/common/event.dto";
import { useSelector } from "react-redux";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import DataNotFound from "components/particles/table/data-not-found";
import EventCard from "components/cards/EventCard";
import Pagination from "components/particles/table/pagination";


const AttendeEvents = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = location.state || {};
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  console.log(params?.id);

  const [filters, setFilters] = useState<EventsFilterDTO>(
    new EventsFilterDTO()
  );
  const { getUserEventsById } = useUsers();
  const [data, setData] = useState<EventDTO[]>([]);
  const [totalElements, setTotalElements] = useState<number>(0);
  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  const buildUpdatedFilters = (
    updates: Partial<EventsFilterDTO> = {},
    resetPage: boolean = false
  ) => {
    const updatedFilters = { ...filters, ...updates };
    if (resetPage) {
      updatedFilters.page = 0;
    }
    return updatedFilters;
  };

  const onPageChange = (pageInfo: { selected: number; limit: number }) => {
    const { selected: page, limit } = pageInfo;
    const updatedFilters = buildUpdatedFilters(
      { size: limit, page: page }, // page is 0-indexed from Pagination (selected)
      false
    );
    setFilters(updatedFilters);
    getAllEvents(updatedFilters);
  };

  const getAllEvents = (filterParams: EventsFilterDTO) => {
    const queryParams: any = { attendeeId: params?.id, status: EVENT_STATUS.JOINED };

    for (let key in filterParams) {
      if (key !== "params?.id" && filterParams[key] !== undefined && filterParams[key] !== null && filterParams[key] !== "") {
        queryParams[key] = filterParams[key];
      }
    }

    // Add pagination params
    queryParams.page = filterParams.page || 0;
    queryParams.size = filterParams.size || 8;

    getUserEventsById(setData, queryParams, setFilters, setTotalElements);
  };

  useEffect(() => {
    getAllEvents(filters);
  }, []);

  const handleFilterChange = (event: any) => {
    const { name, value } = event.target;
    let filterValue: any = value;

    if (name === "isSession") {
      filterValue = value === "" ? undefined : value === "true";
    } else if (name === "isWorkshop") {
      filterValue = value === "" ? undefined : value === "true";
    }

    const updatedFilters = buildUpdatedFilters(
      { [name]: filterValue },
      true
    );
    setFilters(updatedFilters);

    if (name !== "searchTitle") {
      getAllEvents(updatedFilters);
    }
  };

  console.log(data);

  const goToBack = () => {
    navigate(-1);
  };


  const goToEventDetail = (id: number, user: any) => {
    navigate(`${siteRoutes.attendeeEventsDetail}?id=${id}`, { state: { user } });
  };

  return (
    <div>
      <h1 className="text-base text-primaryText font-bold mb-6 flex items-center gap-3">
        <span
          onClick={goToBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        {`${user?.user?.firstName} ${user?.user?.lastName}`}’ Profile
      </h1>
      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-lg p-6">
        <div className="flex justify-between items-center flex-wrap gap-4">
          <div className="flex justify-start items-center gap-2 ">
            <span>
              <img className="w-[82px] h-[82px] rounded-full" src={
                user?.user?.profilePicUrl
                  ? concatPathWithBackendUrl(
                    user?.user?.profilePicUrl?.fileDownloadUri
                  )
                  : editProfilePicUser
              } />
            </span>
            <span>
              <h2 className="text-base whitespace-nowrap font-bold text-primaryText">
                {`${user?.user?.firstName} ${user?.user?.lastName}`}
              </h2>
              <p className="text-xs font-medium text-primaryText">
                {user?.user?.firstName} family
              </p>
            </span>
          </div>
          <div className="flex items-center gap-4">
            <div className="">
              <select
                name="isSession"
                value={filters.isSession ?? ""}
                onChange={handleFilterChange}
                className="px-3 border border-lightGrayBorder text-primaryText outline-none rounded-lg text-sm h-[46px] w-full sm:w-auto min-w-[140px]"
              >
                <option value="">Event Type</option>
                <option value="true">Session</option>
                <option value="false">Workshop</option>
              </select>
            </div>

          </div>
        </div>

        <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 my-6">
            {data.map((exp: EventDTO, index: number) => (
              <EventCard
                key={index + 1}
                event={exp}
                onClick={() => goToEventDetail(exp?.id, user)}
              />
            ))}
          </div>
        </div>
        <div className="">
          <DataNotFound show={!isLoading && !data.length} />
          {totalElements > 0 && (
            <Pagination
              count={totalElements}
              page={(filters.page || 0) + 1}
              limit={filters.size || 8}
              onPageChange={onPageChange}
            />
          )}
        </div>
      </div>

    </div>
  );
};

export default AttendeEvents;
